var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elements",attrs:{"id":"module-builder"}},_vm._l((_vm.modules),function(module,i){return _c(_vm.currentModule(module).component,{key:i,tag:"component",attrs:{"data":_vm.currentModule(module).data}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }